<!-- <mat-form-field class="example-form-field" appearance="outline">
        <mat-label>Search</mat-label>
        <input matInput type="text" [(ngModel)]="value" (keyup)="applyFilter($event)">
    </mat-form-field> -->
<div class="hidden w-full py-2 overflow-auto custom-scroll md:block">
    <table mat-table [dataSource]="dataSource" class="w-full" matSort>
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    color="accent"
                    (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox
                    color="accent"
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)">
                </mat-checkbox>
            </td>
        </ng-container>
        <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
            <th mat-header-cell *matHeaderCellDef [mat-sort-header]="column.columnDef" [disabled]="!column.columnSort">
                <div [class]="column.headerClass">
                    {{ column.header }}
                </div>
            </th>
            <td mat-cell *matCellDef="let row" [class]="column.columnClass">
                <ng-container *ngIf="column.columnType == 'date'">
                    {{ row[column.columnDef] | date: column.columnFormat }}
                </ng-container>
                <ng-container *ngIf="column.columnType == 'number'">
                    {{ row[column.columnDef] | number: column.columnFormat:'es' }}
                </ng-container>
                <ng-container *ngIf="column.columnType == 'currency'">
                    {{ row[column.columnDef] | currency: column.columnFormat:'symbol-narrow':'0.0-0':'es-cl' }}
                </ng-container>
                <ng-container *ngIf="column.columnType == 'custom'">
                    <div [innerHTML]="row['custom_' + column.columnDef]"></div>
                </ng-container>
                <ng-container *ngIf="['date', 'number', 'currency', 'custom'].indexOf(column.columnType) == -1">
                    {{ row[column.columnDef] }}
                </ng-container>
            </td>
        </ng-container>
        <ng-container matColumnDef="detail">
            <th mat-header-cell *matHeaderCellDef>
                <div class="flex flex-col items-center justify-center gap-3 py-3">DETALLE</div>
            </th>
            <td mat-cell *matCellDef="let row" class="text-center paragraph-5">
                <div class="flex items-center justify-center">
                    <button (click)="onTableAction(row)">
                        <mat-icon class="w-[20px] h-[15px] min-w-[20px] min-h-[15px]" svgIcon="icons:eye-icon"> </mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>

<div class="items-center justify-end hidden md:flex">
    <mat-paginator *ngIf="showPaginator" class="flex justify-end text-primary" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons> </mat-paginator>
</div>

<div class="grid grid-cols-1 gap-2 md:hidden sm:grid-cols-2">
    <div
        *ngFor="let row of dataSource?.data"
        class="relative flex flex-col justify-start gap-1 p-4 overflow-hidden text-left transition-all duration-500 ease-in-out border-2 border-gray-200 rounded-lg text-primary-black-01"
        (click)="selectRowMobile($event,row)"
        [ngClass]="{ 'border-primary-blue-01': selection.isSelected(row), 'border-gray-200': !selection.isSelected(row) }"
        class="relative flex flex-col justify-start gap-1 p-4 text-left border-2 rounded-lg">
        <div class="absolute top-5 right-5">
            <svg *ngIf="!selection.isSelected(row)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="7.5" stroke="#e5e7eb" />
            </svg>
            <svg *ngIf="selection.isSelected(row)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="8" fill="#0097A9" />
                <path
                    d="M10.8847 5.2068C11.0256 5.07269 11.213 4.99855 11.4075 5.00002C11.602 5.00149 11.7883 5.07846 11.9272 5.21469C12.066 5.35092 12.1464 5.53575 12.1516 5.73018C12.1567 5.92461 12.0861 6.11343 11.9547 6.2568L7.96471 11.2468C7.8961 11.3207 7.81329 11.38 7.72124 11.4212C7.62919 11.4623 7.52978 11.4845 7.42896 11.4864C7.32814 11.4882 7.22798 11.4698 7.13447 11.432C7.04095 11.3943 6.95601 11.3381 6.88471 11.2668L4.23871 8.6208C4.16502 8.55214 4.10592 8.46934 4.06493 8.37734C4.02394 8.28534 4.00189 8.18603 4.00012 8.08533C3.99834 7.98462 4.01686 7.88459 4.05459 7.79121C4.09231 7.69782 4.14845 7.61298 4.21967 7.54176C4.29089 7.47055 4.37572 7.4144 4.46911 7.37668C4.5625 7.33896 4.66253 7.32043 4.76323 7.32221C4.86393 7.32399 4.96325 7.34603 5.05525 7.38702C5.14725 7.42801 5.23005 7.48712 5.29871 7.5608L7.39271 9.6538L10.8657 5.2288C10.872 5.2211 10.8776 5.21376 10.8847 5.2068Z"
                    fill="white" />
            </svg>
        </div>
        <ng-container *ngFor="let column of columns">
            <p [class]="column.columnClassMobile">
                {{ column.header }} :
                <ng-container *ngIf="column.columnType == 'date'">
                    {{ row[column.columnDef] | date: column.columnFormat }}
                </ng-container>
                <ng-container *ngIf="column.columnType == 'number'">
                    {{ row[column.columnDef] | number: column.columnFormat:'es' }}
                </ng-container>
                <ng-container *ngIf="column.columnType == 'currency'">
                    {{ row[column.columnDef] | currency: column.columnFormat:'symbol-narrow':'0.0-0':'es-cl' }}
                </ng-container>
                <ng-container *ngIf="column.columnType == 'custom'">
                    <div [innerHTML]="row['custom_' + column.columnDef]"></div>
                </ng-container>
                <ng-container *ngIf="['date', 'number', 'currency', 'custom'].indexOf(column.columnType) == -1">
                    {{ row[column.columnDef] }}
                </ng-container>
            </p>
        </ng-container>
        <div class="w-full pt-5 detalle" *ngIf="use_detail">
            <button mat-stroked-button (click)="onTableAction(row)" class="w-11/12 transition-all duration-300 ease-in-out text text-primary-blue-01">
                VER DETALLE
            </button>
        </div>
    </div>
</div>
